<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img class="img-exclusive" src="./assets/img/toplogo.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/news">打印机</el-menu-item>
          <el-menu-item index="/download">下载APP</el-menu-item>
          <el-menu-item index="/product">关于我们</el-menu-item>
          <!-- <el-menu-item index="/case">经典案例</el-menu-item>
          <el-menu-item index="/goin">走进科建</el-menu-item> -->
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div class="footer-content">
          <ul class="content-nav">
            <!-- <li>
              <p>走进科建</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li> -->
            <li>
              <p>联系我们</p>
              <span>邮箱：xiqi@loke123.com</span>
              <span>电话：400515909</span>
              <span
                >地址：深圳市宝安区西乡街道劳动社区西乡大道288号华丰总部经济大厦B座3A06</span
              >
              <span
                >版权：Copyright © 2020-2024 深圳熙琦科技有限公司 All Rights
                Reserved</span
              >

              <a href="https://beian.miit.gov.cn/" target="blank"
                ><span class="beian">备案号：{{ numberInfo }}</span></a
              >
              <div class="user-privacy">
                <a
                  href="https://h5.dolewa.com/outseaUserAgreement.html"
                  target="blank"
                  ><span class="beian">用户协议</span></a
                >
                <a
                  href="https://h5.dolewa.com/outseaUserPrivacy.html"
                  target="blank"
                  ><span class="beian" style="margin-left: 20px"
                    >隐私政策</span
                  ></a
                >
              </div>
            </li>
          </ul>
          <img src="./assets/img/funny_download.png" alt />
        </div>
        <!-- <div class="copyright">
          <span>科建版权所有</span>
        </div> -->
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      numberInfo: "粤ICP备2023052204号-1",
    };
  },
  mounted() {
    var domain = window.location.hostname;
    if (domain == "xiqinet.com" || domain == "www.xiqinet.com") {
      this.numberInfo = "粤ICP备2023052204号-3";
    } else if (domain == "lailaixiong.com.cn") {
      this.numberInfo = "粤ICP备2023052204号-1";
    }
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

.beian {
  text-decoration: underline;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.user-privacy {
  display: flex;
  flex-direction: "row";
}

.img-exclusive {
  width: 100%;
  height: 100%;
  display: block;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 108px;
    height: 45px;
    padding: 10px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 250px;
  overflow: hidden;
  background-color: #3c3c3d;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
